import { Col } from 'antd';

import { Card } from './skeleton-cards.styles';

const SKELETON_LIST = [...Array(3).keys()];

export const SkeletonCards = () => (
  <>
    {SKELETON_LIST.map((index) => (
      <Col key={index} span={8}>
        <Card bordered={false} loading={true} />
      </Col>
    ))}
  </>
);
